import { ErrorResponse, RequestOptions } from "@/types/commonTypes"
import { getTenantHost } from "@/utilities/domain"

const tenantHost = getTenantHost()

export const defaultHeaders = () => ({
  Accept: "application/json",
  "Content-Type": "application/json",
  "X-Tenant": tenantHost,
  Authorization: `Bearer ${
    typeof window !== "undefined" && localStorage.getItem("token")
      ? localStorage.getItem("token")
      : ""
  }`,
})

export const apiFetch = async <R>(
  url: string,
  options: RequestOptions = {},
  handleValidationError?: (data: ErrorResponse) => void
) => {
  // Check if body is FormData - if so, don't set Content-Type header
  const isFormData = options.body instanceof FormData

  if (!isFormData) {
    options.headers = {
      ...defaultHeaders(),
      ...options.headers,
    }
  } else {
    // For FormData, only set Authorization header
    // DO NOT set Content-Type - browser will set it automatically with boundary
    options.headers = {
      "X-Tenant": tenantHost,
      Authorization: `Bearer ${
        typeof window !== "undefined" && localStorage.getItem("token")
          ? localStorage.getItem("token")
          : ""
      }`,
      // Don't spread other headers that might include Content-Type
      ...(options.headers &&
        Object.fromEntries(
          Object.entries(options.headers).filter(
            ([key]) => key.toLowerCase() !== "content-type"
          )
        )),
    }
  }

  const response = await fetch(
    `${import.meta.env.VITE_BASE_URL}/${url}`,
    options
  )

  const contentType = response.headers.get("Content-Type")
  const isJson = contentType && contentType.includes("application/json")
  const data = isJson ? await response.json() : null

  if (!response.ok) {
    // 🔐 Check for 401 and handle globally
    if (response.status === 401) {
      localStorage.removeItem("user")
      window.location.href = "/pos/login"
      return
    }

    // ✅ Handle validation errors (422)
    if (
      response.status === 422 &&
      typeof handleValidationError === "function"
    ) {
      handleValidationError(data)
    }

    throw data
    throw new Error(data?.message || "Something went wrong")
  }

  if (!isJson) {
    throw new Error("Invalid response format")
  }

  return data as R
}
